import { startAuthentication, startRegistration } from "@simplewebauthn/browser";
import { api } from "@/lib/api";

const KEY = "cu-bio-cred";

export const bioLocalId = () => localStorage.getItem(KEY);
export const bioEnabledHere = (user) => Boolean(user?.has_biometric && bioLocalId());

export async function bioSupported() {
  try {
    return Boolean(window.PublicKeyCredential) && (await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable());
  } catch {
    return false;
  }
}

const deviceName = () => {
  const ua = navigator.userAgent;
  if (/iPhone|iPad/.test(ua)) return "iPhone/iPad";
  if (/Android/.test(ua)) return "HP Android";
  if (/Mac/.test(ua)) return "Mac";
  if (/Windows/.test(ua)) return "Windows";
  return "Perangkat";
};

export async function registerBio(pin) {
  const { data: optionsJSON } = await api.post("/webauthn/register/options", { pin });
  const credential = await startRegistration({ optionsJSON });
  await api.post("/webauthn/register/verify", { credential, device: deviceName() });
  localStorage.setItem(KEY, credential.id);
}

export async function removeBio(id) {
  await api.delete(`/webauthn/credentials/${encodeURIComponent(id)}`);
  if (id === bioLocalId()) localStorage.removeItem(KEY);
}

export const forgetBioHere = () => localStorage.removeItem(KEY);

export async function bioAssert(purpose, extra = {}) {
  const { data: optionsJSON } = await api.post("/webauthn/auth/options", { purpose, ...extra });
  return startAuthentication({ optionsJSON });
}

export async function bioUnlock() {
  const credential = await bioAssert("unlock");
  const { data } = await api.post("/webauthn/unlock", { credential });
  return data;
}

export const bioCancelled = (e) => ["NotAllowedError", "AbortError"].includes(e?.name);

const APPROVAL_KEY = "cu-bio-approval";
export const approvalBioHere = () => localStorage.getItem(APPROVAL_KEY);

export async function registerApprovalBio(superPin) {
  const { data: optionsJSON } = await api.post("/webauthn/approval/register/options", {}, { headers: { "X-Approval-Pin": superPin } });
  const credential = await startRegistration({ optionsJSON });
  await api.post("/webauthn/approval/register/verify", { credential, device: deviceName() });
  localStorage.setItem(APPROVAL_KEY, credential.id);
}

export async function removeApprovalBio(id) {
  await api.delete(`/webauthn/credentials/${encodeURIComponent(id)}`);
  if (id === approvalBioHere()) localStorage.removeItem(APPROVAL_KEY);
}

export async function approvalAssert(method, path) {
  const { data: optionsJSON } = await api.post("/webauthn/approval/options", { method, path });
  return startAuthentication({ optionsJSON });
}

export const forgetApprovalHere = () => localStorage.removeItem(APPROVAL_KEY);
